<template>
  <div class="page-modal">
    <!-- Many -->
    <widgetModal :footerhidden="true" :headerhidden="true" footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px" body_padding="30px 30px" width="500px" :hiderightbtn="true">

      <div class="widget-modal-body-noscoll">
        <uploadManyItems file="https://storage.googleapis.com/consultified_media/files/templates/NotesTemplate.xlsx"
          title="Upload Notes" description="To upload many notes as file, you need to download the .xl file
              template here. Add notes to the file and then repload it in the
              next step." actiontext="Upload below the filled document with accounts" @back="onCancel()"
          @onFile="(file) => { if (file) { form.selected_file = file; } }" :loading="adding_upload_loading"
          @onSubmit="onConfirm"></uploadManyItems>
      </div>
    </widgetModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  props: {
  },
  data() {
    let vm = this;
    return {
      form: {
        selected_file: null,
        account_id: vm.$route.params.id,
        owner: null
      },
      adding_upload_loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    onConfirm() {
      let vm = this;
      vm.form.owner = {
        name: vm.$getLoggedUser().manager_name,
        profile_image: vm.$getLoggedUser().manager_picture,
      };
      const rules = {
        selected_file: {
          run: (value) => {
            if (value) {
              return false;
            }
            return "File template not selected";
          },
        },
      };

      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.adding_upload_loading = true;
        let form_data = new FormData();
        form_data.append("account_id", vm.form.account_id);
        form_data.append("owner", JSON.stringify(vm.form.owner));
        form_data.append(
          "file",
          vm.form.selected_file,
          vm.form.selected_file.name
        );

        vm.$store
          .dispatch("NOTES_UPLOAD_NOTES", form_data)
          .then((response) => {
            vm.adding_upload_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Notes uploaded successfully",
              type: "success",
              duration: 3000,
            });
            vm.$emit("success", null);
          })
          .catch((error) => {
            vm.adding_upload_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.page-modal {}
</style>